import Vue from 'vue';
import _ from 'lodash-extended';

/**
 * Emit event to component
 * and also bind event name to component method if exists
 *
 * @usage
 * when needed:
 * tmBus.mind(this, ['event', ...]);
 *
 * in beforeDestroy:
 * storyViewBus.neverMind(this);
 */
export default new Vue({
  methods: {
    mind(component, events, emit = false) {
      component.$options.__timemachineOffListeners = [];
      _.each(events, (event) => {
        const proxy = function (...args) {
          // console.log('tmBus', event /* , ...args*/);
          component.$emit(event, ...args);
        };
        this.$on(event, proxy);
        component.$options.__timemachineOffListeners.push(() => {
          this.$off(event, proxy);
        });

        const method = component[event];
        if (method) {
          this.$on(event, method);
          component.$options.__timemachineOffListeners.push(() => {
            this.$off(event, method);
          });
        }
      });
    },

    neverMind(component) {
      _.each(component.$options.__timemachineOffListeners, (off) => off());
    },
  },
});
